import React from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <section className="pt-28 pb-20">
        <div className="max-w-3xl mx-auto px-6">
          <h1 className="text-4xl font-medium text-slate-900 mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>Privacy Policy</h1>
          <p className="text-sm text-slate-400 mb-10">Last updated: January 2026</p>
          <div className="prose prose-slate max-w-none space-y-8 text-slate-700">
            <section>
              <h2 className="text-xl font-semibold text-slate-900 mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>1. Information We Collect</h2>
              <p>When you interact with AvA or submit an intake through the Apexum Partners platform, we collect the information you provide, including your name, email address, phone number, clinic details, provider information, and service preferences. We also collect usage data such as browser type, IP address, and pages visited.</p>
            </section>
            <section>
              <h2 className="text-xl font-semibold text-slate-900 mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>2. How We Use Your Information</h2>
              <p>We use the information you provide to evaluate clinic qualification, route your organization to appropriate pathways, and follow up with relevant information about Apexum's services. We do not sell your personal information to third parties.</p>
            </section>
            <section>
              <h2 className="text-xl font-semibold text-slate-900 mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>3. Data Storage and Security</h2>
              <p>Your information is stored securely using industry-standard encryption. We take reasonable steps to protect your information from unauthorized access, disclosure, or loss. However, no method of electronic transmission or storage is 100% secure.</p>
            </section>
            <section>
              <h2 className="text-xl font-semibold text-slate-900 mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>4. Sharing of Information</h2>
              <p>We may share your information with our network of qualified vendor partners for the purpose of evaluating potential pathway fit, subject to their own privacy policies and applicable law. We will not share your information with unrelated third parties without your consent.</p>
            </section>
            <section>
              <h2 className="text-xl font-semibold text-slate-900 mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>5. Your Rights</h2>
              <p>You may request access to, correction of, or deletion of your personal information by contacting us. We will respond to such requests within 30 days.</p>
            </section>
            <section>
              <h2 className="text-xl font-semibold text-slate-900 mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>6. Contact</h2>
              <p>If you have questions about this Privacy Policy, please contact the Apexum Partners team. This platform is operated by Apexum Partners.</p>
            </section>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
